import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Global site footer — appears on all protected pages.
 * Owns the copyright line and links to governance documents.
 */
export default function SiteFooter() {
  const year = new Date().getFullYear();
  return (
    <footer
      className="border-t border-slate-200 bg-white mt-12 pb-20 md:pb-6 pt-6"
      data-testid="site-footer"
    >
      <div className="container mx-auto px-4 md:px-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-slate-500">
        <p data-testid="footer-copyright">
          Shape Tomorrow Limited © 2026
        </p>
        <nav className="flex items-center gap-4 flex-wrap" data-testid="footer-nav">
          <Link to="/governance/terms-of-use" className="hover:text-brand-navy hover:underline">Terms of Use</Link>
          <span className="text-slate-300">·</span>
          <Link to="/governance/community-guidelines" className="hover:text-brand-navy hover:underline">Community Guidelines</Link>
          <span className="text-slate-300">·</span>
          <Link to="/governance/privacy-policy" className="hover:text-brand-navy hover:underline">Privacy Policy</Link>
        </nav>
      </div>
    </footer>
  );
}
